import User from '@services/user/User.model';
import { interfaces } from 'inversify';
import LogEntryModel from './LogEntry.model';

export default interface ILoggingService {
  log: (entry: LogEntryModel) => void;
  registerUser: (user: User) => void;
  page: (title: string, url: string) => void;
}

const ILoggingService$: interfaces.ServiceIdentifier<ILoggingService> = Symbol('ILoggingService');
export { ILoggingService$ };
